import { ArrowRightAlt } from "@mui/icons-material";
import { Box, Card, CardMedia, Typography } from "@mui/material";
import { Stack } from "@mui/system";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./BlogItem.css";
import { tokens } from "../../../store/tokens";

const BlogItem = (props) => {
  const navigate = useNavigate();
  const { blogData } = props;
  const { blog_id, pic, category, article_info, con_image, title, timeStamp } =
    blogData;
  // NOTE: added the extra `?.` before slice — article_info?.[0] being present
  // didn't guarantee `.details` existed, so this could throw on real data.
  const detail = article_info?.[0]?.details?.slice(0, 140);

  return (
    <Card
      onClick={() => navigate("/blogdetails/" + pic)}
      sx={{
        width: "100%",
        borderRadius: `${tokens.card.radius}px`,
        cursor: "pointer",
        border: `1px solid ${tokens.color.line}`,
        bgcolor: tokens.bg.surface,
        boxShadow: tokens.shadow.sm,
        transition: "box-shadow 0.25s ease, border-color 0.25s ease, transform 0.25s ease",
        "&:hover": {
          boxShadow: tokens.shadow.md,
          borderColor: tokens.color.teal,
          transform: "translateY(-3px)",
        },
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {/* Image Section */}
      <Box sx={{ position: "relative", height: { xs: 180, md: 220 } }}>
        <CardMedia
          component="img"
          src={
            con_image?.[0]?.pic_url
              ? "//yeapbe.com/" + con_image[0].pic_url
              : "//aps.songjukti.com/image/catPic/creative_work.jpg"
          }
          alt={title}
          sx={{ width: "100%", height: "100%", objectFit: "cover" }}
        />

        {/* Blog ID Tag */}
        <Box
          sx={{
            position: "absolute",
            bottom: 12,
            left: 12,
            bgcolor: tokens.color.tealDark,
            px: 2,
            py: 0.5,
            borderRadius: `${tokens.radius.sm}px`,
            boxShadow: `0 0 8px ${tokens.color.teal}AA`,
            fontWeight: "bold",
            fontSize: 16,
            color: "#fff",
            userSelect: "none",
            fontFamily: tokens.font.heading,
          }}
        >
          #{blog_id}
        </Box>
      </Box>

      {/* Content Section */}
      <Stack
        spacing={1}
        sx={{
          p: { xs: 2, md: 3 },
          flexGrow: 1,
          justifyContent: "space-between",
        }}
      >
        {/* Title */}
        <Typography
          variant="h6"
          component="h2"
          noWrap
          title={title}
          sx={{
            fontWeight: 700,
            fontSize: { xs: "1rem", md: "1.125rem" },
            color: tokens.color.ink,
            lineHeight: 1.3,
            fontFamily: tokens.font.heading,
          }}
        >
          {title}
        </Typography>

        {/* Meta info */}
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          sx={{
            fontFamily: tokens.font.body,
            fontSize: { xs: "0.8rem", md: "0.9rem" },
          }}
        >
          <Typography noWrap sx={{ color: tokens.textOn.light.secondary, fontSize: "inherit" }}>
            {timeStamp}
          </Typography>
          <Typography sx={{ color: tokens.color.line, fontSize: "inherit" }}>|</Typography>
          <Typography sx={{ color: tokens.color.teal, fontWeight: 600, fontSize: "inherit" }}>
            {category}
          </Typography>
        </Stack>

        {/* Excerpt */}
        {detail && (
          <Typography
            sx={{
              fontFamily: tokens.font.body,
              fontSize: "0.85rem",
              color: tokens.textOn.light.secondary,
              lineHeight: 1.55,
              display: "-webkit-box",
              WebkitLineClamp: 2,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {detail}…
          </Typography>
        )}

        {/* Read more */}
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ pt: 0.5 }}>
          <Typography
            sx={{
              fontFamily: tokens.font.body,
              fontSize: "0.85rem",
              fontWeight: 600,
              color: tokens.color.teal,
            }}
          >
            Read more
          </Typography>
          <ArrowRightAlt sx={{ fontSize: "1.1rem", color: tokens.color.teal }} />
        </Stack>
      </Stack>
    </Card>
  );
};

export default BlogItem;